
class Cart {
  constructor(componentName){
    this.cart = document.getElementsByClassName(componentName)[0];
  }

  updateCart(units, priceOverview) {
    const totalUnits = this.cart.getElementsByClassName('total-items-amount')[0];
    totalUnits.textContent = units;

    this.updatePriceOverviewCard(priceOverview);
  }

  updatePriceOverviewCard(newContent) {
    const priceOverviewCard = document.getElementById('cart-total-prices');
    if (!!priceOverviewCard) {
      const content = app.parser.parseToHTML(newContent);
      priceOverviewCard.innerHTML = '';
      priceOverviewCard.appendChild(content);
    }
  }

  addProduct(productString) {
    const productsInCart = document.getElementsByClassName('list--products-in-cart')[0];
    if(productsInCart) {
      productsInCart.appendChild(app.parser.parseToHTML(productString));
    }
  }

  removeProduct(productId) {
    const products = document.querySelectorAll(`article[data-product-id='${productId}']`);

    for(let product of products) {
      const li = product.parentElement;
      if(li.classList.contains('gift')) li.parentNode.removeChild(li);
    }
  }

  checkAvailableCoupons(url) {
    app.ajax.rails(url, 'GET');
  }

  // Target will be either the default string OR the productID
  // Type will be either the default 'coupon' OR 'coupon-available' OR empty string

  // SAMPLE CALLS
  // app.components.cart.addDiscount('overview-totals', {message: 'Super descuento', type: 'coupon'});
  // app.components.cart.addDiscount(1881, {message: 'Super descuento', type: 'coupon-available'});
  addDiscount(target = 'overview-totals', { id, message, type = 'coupon'}) {
    let discountsList;
    // Target the proper discount list
    if(target === 'overview-totals') {
      const overview = document.getElementById('cart-total-prices');
      discountsList = overview.getElementsByClassName('list--discounts')[0];
    } else {
      const products = document.querySelectorAll(`article[data-product-id='${target}']`);
      for (let product of products) {
        const li = product.parentElement;

        // Add coupon only if not
        if (!li.classList.contains('gift') && !li.classList.contains('product-cart-feedback')) {
          discountsList = product.getElementsByClassName('list--discounts')[0];
        }
      }
    }


    if(discountsList) {
      // Append the new discount tag if doesn't exist
      if(!discountsList.querySelector(`li[data-id="${id}"]`)) {
        const discount = app.parser.parseToHTML(`<li class='discount-applied ${type}' data-id='${id}' title='${stripHtml(message)}'><span>${message}</span></li>`);
        discountsList.appendChild(discount);
      }
    } else {
      console.warn(`The coupon list: ${target} doesn't exist 🤯`);
    }
  }
}

export default Cart;
